module.exports = __webpack_public_path__ + "img/cap_11.2e2c7bef.jpg";